export const attentiveIdentifyCustomer = async (userEmail) => {
  /* if (userEmail) {
    dataLayer.push({
      event: "attentivePopup",
      identify_email: userEmail,
    });
  } */
};
